import { Component, Input, OnInit } from '@angular/core';
import { Option } from '@dch/products-business-logic';
import {
  ApplicationState,
  getNetflixToken,
  getNetflixTokenError,
} from '../../../store/reducers';
import { Store } from '@ngrx/store';
import { OnDestroyHookDirective } from '../../../shared/hooks';
import { GetNetflixWebToken } from '../../../store/actions/netflix-account-management.actions';
import { EnvironmentService, LanguageService, TranslationService } from "@proximus/ng-common";
import { Alert, AlertsService } from '@proximus/ng-common-components';

@Component({
  selector: 'mprd-netflix-account-management',
  templateUrl: './netflix-account-management.component.html',
})
export class NetflixAccountManagementComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  @Input()
  option: Option;

  constructor(
    private store: Store<ApplicationState>,
    private languageService: LanguageService,
    private alertService: AlertsService,
    private translationService: TranslationService,
    private environmentService: EnvironmentService,
  ) {
    super();
  }

  ngOnInit() {
    this.addSubscription(
      this.store.select(getNetflixToken).subscribe((value) => {
        if (value && value.token) {
          const url = this.getRedirectLinkUrl().replace(
            '<token_value>',
            value.token,
          );
          const target = this.environmentService.isProximusPlusMobileApp ? '_self' : '_blank'
          window.open(url, target);
        }
      }),
    );

    this.addSubscription(
      this.store.select(getNetflixTokenError).subscribe((error) => {
        if (error) {
          const alert: Alert = {
            isClosable: true,
            alertKey:
              this.option.optionCodeForDescription +
              'netflixAccountManagementAlertLevel3',
            title: this.translationService.getTranslatedValueFor(
              'option.details.netflix.error.title',
            ),
            description: this.translationService.getTranslatedValueFor(
              'option.details.netflix.error.description',
            ),
            type: 'error',
            useNegativeColors: true,
          };
          this.alertService.dispatchAlert(alert);
        }
      }),
    );
  }

  public getNetflixToken() {
    this.store.dispatch(new GetNetflixWebToken());
  }

  public getRedirectLinkLabel(): string {
    if (
      this.option &&
      this.option.redirectLink &&
      this.option.redirectLink.label
    ) {
      return this.option.redirectLink.label[
        this.languageService.getSelectedLanguage()
      ];
    }
    return this.translationService.getTranslatedValueFor(
      'option.details.netflix.manageLink',
    );
  }

  private getRedirectLinkUrl(): string {
    if (
      this.option &&
      this.option.redirectLink &&
      this.option.redirectLink.url
    ) {
      return this.option.redirectLink.url[
        this.languageService.getSelectedLanguage()
      ];
    }
    return '';
  }
}
